import axios, { AxiosInstance } from "axios";
import store from "@/store";
import KeyCloak from "@/common/module/keyCloak";

interface AxiosInstanceVersion extends AxiosInstance {
  version: (version: string) => AxiosInstance;
}

export class HttpAxios {
  public static instancesForRefreshToken = [
    "bffC",
    "bffMailSender",
    "bffSysops",
    "bffJourney",
    "bffIntegration",
    "bffInsights",
    "bffZendesk",
  ];
  public static tokenBff = "";

  public static EtherApi = HttpAxios.create(
    process.env.VUE_APP_KONG_ETHER_API as string,
    "",
    "",
    false,
    {
      apiKey: process.env.VUE_APP_ETHER_API_TOKEN,
      authorization: false,
    }
  );

  public static mock = HttpAxios.create(
    process.env.VUE_APP_MOCKUP as string,
    ""
  );
  public static bffC: AxiosInstanceVersion;
  public static bffMailSender: AxiosInstanceVersion;
  public static bffSysops: AxiosInstanceVersion;
  public static bffJourney: AxiosInstanceVersion;
  public static bffIntegration: AxiosInstanceVersion;
  public static bffInsights: AxiosInstanceVersion;
  public static userGateway: AxiosInstanceVersion;
  public static bffZendesk: AxiosInstanceVersion;
  public static connectionWS: string;

  private constructor() {} // eslint-disable-line

  public static async initWithKeyCloak(token = "", dxpAccountId = "") {
    HttpAxios.tokenBff = token;
    HttpAxios.connectionWS = process.env.VUE_APP_WS + "/v2";

    HttpAxios.userGateway = HttpAxios.create(
      process.env.VUE_APP_API_DXP_USER_GATEWAY!,
      `Bearer ${HttpAxios.tokenBff}`,
      "/v1",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
        apikey: process.env.VUE_APP_API_DXP_USER_GATEWAY_KONG_KEY,
      }
    );

    HttpAxios.bffC = HttpAxios.create(
      process.env.VUE_APP_NEW_BFF!,
      `Bearer ${HttpAxios.tokenBff}`,
      "/v2",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
      }
    );

    HttpAxios.bffMailSender = HttpAxios.create(
      process.env.VUE_APP_MAILSENDER_BFF as string,
      `Bearer ${HttpAxios.tokenBff}`,
      "v2",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
      }
    );

    HttpAxios.bffSysops = HttpAxios.create(
      process.env.VUE_APP_SYSOPS_BFF!,
      `Bearer ${HttpAxios.tokenBff}`,
      "/v2",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
      }
    );

    HttpAxios.bffJourney = HttpAxios.create(
      process.env.VUE_APP_JOURNEY_BFF!,
      `Bearer ${HttpAxios.tokenBff}`,
      "/v1",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
      }
    );

    HttpAxios.bffIntegration = HttpAxios.create(
      process.env.VUE_APP_INTEGRATION_BFF!,
      `Bearer ${HttpAxios.tokenBff}`,
      "/v1",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
      }
    );

    HttpAxios.bffZendesk = HttpAxios.create(
      process.env.VUE_APP_ZENDESK_API!,
      `Bearer ${HttpAxios.tokenBff}`,
      "",
      false,
      {
        "x-dxp-account-id": dxpAccountId,
      }
    );

    HttpAxios.bffInsights = HttpAxios.create(
      process.env.VUE_APP_INSIGHTS_BFF!,
      `Bearer ${HttpAxios.tokenBff}`,
      process.env.VUE_APP_INSIGHTS_VERSION_BFF,
      false,
      {
        "x-dxp-account-id": dxpAccountId,
        apikey: process.env.VUE_APP_INSIGHTS_APIKEY_BFF,
      }
    );
  }

  public static updateHeader(
    nameInstance: string,
    nameHeader: string,
    value: string
  ) {
    HttpAxios[nameInstance].defaults.headers[nameHeader] = value;
  }

  public static updateAuthorizationToken(token: string) {
    HttpAxios.tokenBff = token;
    HttpAxios.instancesForRefreshToken.forEach((instanceName) => {
      HttpAxios[
        instanceName
      ].defaults.headers.Authorization = `Bearer ${token}`;
    });
  }

  public static create(
    path: string,
    authorization: string,
    version = "",
    withCredentials = false,
    headers = {}
  ): AxiosInstanceVersion {
    const newInstanceAxios: AxiosInstanceVersion = axios.create({
      baseURL: path + version,
      withCredentials,
      headers: {
        Authorization: authorization,
        ...headers,
      },
    }) as AxiosInstanceVersion;

    newInstanceAxios.interceptors.request.use(
      (config) => {
        store.dispatch("loading/SET_LOADING", false);

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    newInstanceAxios.interceptors.response.use(
      (response) => {
        store.dispatch("loading/SET_LOADING", true);

        return response;
      },
      (error) => {
        if (error?.response?.status === 401) {
          KeyCloak.redirectAuth();
        }
        store.dispatch("loading/SET_LOADING", true);
        return Promise.reject(error);
      }
    );

    newInstanceAxios.version = (version: string): AxiosInstance => {
      return HttpAxios.create(
        path,
        authorization,
        version,
        withCredentials,
        headers
      );
    };

    return newInstanceAxios;
  }
}
